import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e7bb256"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "policy" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_divider = _resolveComponent("van-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.is_hide_header)
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          title: $setup.title,
          menuState: "",
          skipPath: _ctx.skipPath,
          backgroundColor: "#424040",
          fontColor: "#fff"
        }, null, 8, ["title", "skipPath"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", {
        innerHTML: $setup.datas.title
      }, null, 8, _hoisted_2),
      _createElementVNode("h2", null, _toDisplayString($setup.datas.updated_at), 1),
      _createVNode(_component_van_divider),
      _createElementVNode("div", {
        id: "helpInfo",
        innerHTML: $setup.datas.content
      }, null, 8, _hoisted_3)
    ])
  ], 64))
}